import { Button } from '~/shared/ui/Buttons'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { ButtonsWrapper, Title } from './styled'

type DeleteCardDrawerProps = {
  isShow: boolean
  onClose: () => void
  onDelete: () => void
  isLoading: boolean
}

export function DeleteCardDrawer({
  isShow,
  onClose,
  onDelete,
  isLoading,
}: DeleteCardDrawerProps) {
  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      <Title>Удалить карту?</Title>

      <ButtonsWrapper>
        <Button
          fullWidth
          variant='lightSteelBlueBorder'
          size='large'
          onClick={onClose}
          disabled={isLoading}
        >
          Отмена
        </Button>
        <Button
          loading={isLoading}
          fullWidth
          variant='limeFlooded'
          size='large'
          onClick={onDelete}
        >
          Удалить
        </Button>
      </ButtonsWrapper>
    </DrawerComponent>
  )
}
